/**
 * Created by shubham on 23/4/18.
 */

import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appBlockCutCopyPaste]'
})
export class BlockCutCopyPasteDirective {
    constructor() {
    }

    @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
        console.log("Can not paste here");
        e.preventDefault();
    }

    @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
        console.log("Can not copy here");
        e.preventDefault();
    }

    @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
        console.log("Can not cut here");
        e.preventDefault();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/directive/blockCutCopyPaste.directive.ts